<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row class="details">
              <b-col xs="12" sm="12" md="12" class="text-right mb-2">
                    <b-button class="text-right" @click="pdfExport()" variant="success">{{  $t('globalTrans.export_pdf') }}</b-button>
              </b-col>
                <b-col lg="12" sm="12">
                    <b-row>
                        <b-col lg="12" sm="12">
                            <b-row>
                                <b-col md=12>
                                    <b-table-simple striped bordered small hover>
                                        <tbody>
                                           <b-tr>
                                                <b-th colspan="1">{{ $t('grant_budget_management.fiscal_year') }}</b-th>
                                                <b-td colspan="5">{{ (currentLocale === 'en') ? profile.fiscal_name : profile.fiscal_name_bn }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="1">{{ $t('grant_config.organization') }}</b-th>
                                                <b-td colspan="5">{{ getOrgName(profile.org_id) }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="1">{{ $t('grant_config.service_type') }}</b-th>
                                                <b-td colspan="5">{{ getServiceType(profile.service_type_id) }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="1">{{ $t('grant_config.service_name') }}</b-th>
                                                <b-td colspan="5">{{ getService(profile.service_id) }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="1">{{ $t('grant_registration.start_date') }}</b-th>
                                                <b-td colspan="5">{{ profile.start_date | dateFormat }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="1">{{ $t('grant_registration.end_date') }}</b-th>
                                                <b-td colspan="5">{{ profile.end_date | dateFormat }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="1">{{ $t('grant_registration.notice_title') }}</b-th>
                                                <b-td colspan="5">{{ (currentLocale === 'en') ? profile.notice : profile.notice_bn }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="1">{{ $t('grant_registration.notice_description') }}</b-th>
                                                <b-td colspan="5">{{ (currentLocale === 'en') ? profile.description : profile.description_bn }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-th colspan="1">{{ $t('globalTrans.attachment') }}</b-th>
                                                <b-td colspan="5">
                                                  <a :href="url + 'storage/registration-management/prepare-notice/original/' + profile.attachment" title="Attachment"><span v-if="profile.attachment">{{ profile.attachment }} <i class="ri-download-cloud-fill"></i></span></a>
                                                </b-td>
                                            </b-tr>
                                        </tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="text-right">
                  <b-button v-if="!profile.is_send" @click="send" :disabled="loadingBtn" variant="primary">{{ $t('globalTrans.send') }}</b-button>
                                               &nbsp;
                  <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-2')">{{ $t('globalTrans.cancel') }}</b-button>
                </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ExportPdf from './export-pdf_details'
import RestApi, { grantAllowanceServiceBaseUrl } from '@/config/api_config'
import { noticeSendApi } from '../../api/routes'
import ConfirmationPopup from '@/Utils/confirmation-message'

export default {
    props: ['id'],
    data () {
        return {
            loadingBtn: false,
            profile: {},
            url: grantAllowanceServiceBaseUrl
        }
    },
    created () {
      if (this.id) {
        this.profile = this.getApplicationFormData()
      }
    },
    computed: {
      currentLocale: function () {
        return this.$i18n.locale
      }
    },
    methods: {
      send () {
          var message = this.$t('grant_registration.sendMsg')
          ConfirmationPopup(message, (response) => {
            if (response === true) {
              this.$store.dispatch('mutateCommonProperties', { loading: true })
              const loadingState = { loading: false, listReload: true }
              if (this.id) {
                  this.loadingBtn = true
                  RestApi.postData(grantAllowanceServiceBaseUrl, noticeSendApi, this.profile).then(response => {
                      this.$store.dispatch('mutateCommonProperties', loadingState)
                      if (response.success) {
                        const notification = response.notification
                        if (notification && this.$store.state.emitNotification) {
                          this.$socket.emit('send-notification', notification)
                        }
                          this.$toast.success({
                              title: this.$t('globalTrans.success'),
                              message: this.$t('globalTrans.update_msg'),
                              color: '#D6E09B'
                          })
                          this.$bvModal.hide('modal-2')
                      } else {
                          this.$toast.error({
                              title: this.$t('globalTrans.error'),
                              message: this.$t('globalTrans.operationFailed')
                          })
                      }
                      this.loadingBtn = false
                  })
              }
            }
          })
        },
        getApplicationFormData () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return tmpData === undefined ? {} : JSON.parse(JSON.stringify(tmpData))
        },
        getOrgName (orgId) {
          const orgName = this.$store.state.orgList.find(item => item.value === orgId)
          if (this.$i18n.locale === 'bn') {
            return orgName.text_bn
          } else {
            return orgName.text
          }
        },
        getServiceType (serviceTypeId) {
          const serviceType = this.$store.state.GrantAllowanceService.commonObj.serviceTypeList.find(item => item.value === serviceTypeId)
          if (this.$i18n.locale === 'bn') {
            return serviceType.text_bn
          } else {
            return serviceType.text_en
          }
        },
        getService (serviceId) {
          const service = this.$store.state.GrantAllowanceService.commonObj.serviceNameList.find(item => item.value === serviceId)
          if (this.$i18n.locale === 'bn') {
            return service.text_bn
          } else {
            return service.text
          }
        },
        pdfExport () {
            const reportTitle = this.$t('grant_registration.prepare_notice') + ' ' + this.$t('globalTrans.details')
            ExportPdf.exportPdfDetails(grantAllowanceServiceBaseUrl, 'configuration/report-heading/detail', this.profile.org_id, reportTitle, this.profile, this)
        }
    }
}
</script>
<style lang="scss">
    .details {
    h5 {
      color: green !important;
      font-size: 20px !important;
    }
    .table-bordered td:nth-child(2n+1) {
      font-weight: 700;
    }
  }
  .hidden_header {
    display: none
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
</style>
